import React, { useContext, useEffect } from 'react'
import { catalogProductOptionalField, EcomProduct } from '../../../../models/axiosModel'
import { Chip, Divider, Grid, Typography } from '@mui/material';
import { getValueOrDefault } from '../../../../utils/constants';
import popupStyles from "../../../../assets/styles/componentStyles/globalPopupStyles.module.scss"
import globalStyles from "../../../../assets/styles/global.module.scss"
import { useProductStore } from '../../../../store/productStore';
import { useShallow } from 'zustand/react/shallow';
import styles from "../../../../assets/styles/componentStyles/productStyles/productStyles.module.scss"
import { useGenericStore } from '../../../../store/genericStore';
import { getGenericDataTypeName, OPTIONAL_DATE_RANGE_DISPLAY_FORMAT, parseOptionalDateRangeValue } from './productConstant';
import { UserContext, UserContextPayload } from '../../../../context/userContext';

interface ViewCatalogOptionalDataPopupProps {
    selectedProduct: EcomProduct
} 

const ViewCatalogOptionalDataPopup = (props: ViewCatalogOptionalDataPopupProps) => {
    
    const { selectedProduct } = props;

    const innerHeight = window.innerHeight - 180;

    const { catalogProductOptionalFieldData } = useProductStore(useShallow((state) => ({
        catalogProductOptionalFieldData: state.catalogProductOptionalFieldData
    }))); 

    const { genericDataTypeList, getGenericDataTypeApi } = useGenericStore(useShallow((state) => ({
        genericDataTypeList: state.genericDataTypeList,
        getGenericDataTypeApi: state.getGenericDataTypeApi
    })))

    const { setFlagLoading, handleError} = useContext(UserContext) as UserContextPayload;

    const getGenericDataTypeListApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getGenericDataTypeApi();
        if(!(res?.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!genericDataTypeList){
            getGenericDataTypeListApiCall();
        }
    }, []);

     const formatFieldValueForDisplay = (value: string, dataType: string) => {
        if (dataType !== "date range") {
            return value;
        }

        const { startDate, endDate } = parseOptionalDateRangeValue(value);
        if (!startDate?.isValid?.()) {
            return value;
        }

        const formattedStartDate = startDate.format(OPTIONAL_DATE_RANGE_DISPLAY_FORMAT);
        if (!endDate?.isValid?.()) {
            return `${formattedStartDate} -`;
        }

        return `${formattedStartDate} - ${endDate.format(OPTIONAL_DATE_RANGE_DISPLAY_FORMAT)}`;
    };

    const renderOptionalFieldValue = (optionalField: catalogProductOptionalField) => {
        const flagMultipleField = optionalField?.flag_allowed_multiple;
        const dataType = getGenericDataTypeName(optionalField?.data_type_id, genericDataTypeList)?.toLowerCase();
        const optionalFieldValues = (selectedProduct?.catalog_product_optional_data ?? [])?.filter((item) => item?.catalog_product_optional_field_id === optionalField?.catalog_product_optional_field_id)?.map((item) => String(item?.catalog_product_optional_data_value ?? "").trim())?.filter((value) => value.length > 0);

        if (!optionalFieldValues.length) {
            return <Typography className={styles.catalogOptionalFieldValue}>-</Typography>;
        }

        if (flagMultipleField) {
            return (
                <Grid container gap={0.5}>
                    {optionalFieldValues.map((value, index) => (
                        <Grid item key={`${optionalField?.catalog_product_optional_field_id}-${index}`}>
                            {dataType === "url" ? (
                                <Chip
                                    component="a"
                                    clickable
                                    href={value}
                                    target="_blank"
                                    rel="noreferrer"
                                    label={formatFieldValueForDisplay(value, dataType)}
                                    size="small"
                                    className={styles.catalogMultipleFieldChip}
                                />
                            ) : (
                                <Chip label={formatFieldValueForDisplay(value, dataType)} size="small" className={styles.catalogMultipleFieldChip} />
                            )}
                        </Grid>
                    ))}
                </Grid>
            );
        }

        const value = optionalFieldValues[0];
        if (dataType === "url") {
            return (
                <a href={value} target="_blank" rel="noreferrer" className={styles.catalogOptionalFieldValue}>
                    {formatFieldValueForDisplay(value, dataType)}
                </a>
            );
        }

        return <Typography className={styles.catalogOptionalFieldValue}>{getValueOrDefault(formatFieldValueForDisplay(value, dataType))}</Typography>;
    }
    
    return (
        <>
            <Grid item xs={12}>
                <Grid container direction={"column"} justifyContent={"center"}>
                    <Grid item textAlign={"center"}>
                        <Typography className={popupStyles.popupTitleTypography}>
                            {`Catalog Optional Data Of ${selectedProduct?.ecom_product_name}`}
                        </Typography>
                    </Grid>

                    <Divider className={popupStyles.popupTitleDivider} /> 

                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container className={`${popupStyles.popupBodyGridContainer} ${globalStyles.overflowAuto}`} gap={2} sx={{ maxHeight: `${innerHeight}px !important` }}>
                            {catalogProductOptionalFieldData && 
                                <Grid item xs={12} className={`${globalStyles.fullwidth} ${styles.catalogOptionalFieldDataGrid}`}>
                                    <Grid container spacing={2}>
                                        {catalogProductOptionalFieldData?.map((optionalField: catalogProductOptionalField) => {
                                            return (
                                                <Grid item lg={6} xs={12} key={optionalField?.catalog_product_optional_field_id}>
                                                    <Grid container direction={'column'} gap={0.5}>
                                                        <Grid item xs={12}>
                                                            <Typography className={styles.catalogOptionalFieldTitle}>
                                                                {optionalField?.field_name}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            {renderOptionalFieldValue(optionalField)}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ViewCatalogOptionalDataPopup
